import type { FC } from 'react';
import { useController, useFormContext } from 'react-hook-form';

import { Tag, Range } from '@catalyze/ui';

type IRangeMenuRangeProps = {
    inputName: string;
    textTransform?: (min: string, max: string) => string;
    show: boolean;
};

export const RangeMenuTags: FC<IRangeMenuRangeProps> = ({
    textTransform,
    inputName,
    show,
}) => {
    const { resetField, watch } = useFormContext();
    const {
        fieldState: { isDirty },
    } = useController({ name: inputName });
    const { [Range.MAX]: max, [Range.MIN]: min } = watch(inputName);
    if (!isDirty && !show) return null;
    return (
        <Tag
            value={textTransform ? textTransform(min, max) : `${min} - ${max}`}
            onDelete={() => resetField(inputName)}
        />
    );
};

RangeMenuTags.defaultProps = {
    textTransform: undefined,
};
